import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatButton } from '@angular/material/button';
import { Observable, Subject } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { WebsocketService } from './websocket.service';
import { StatutNotificationEnum } from './statut.enum';
import { Criteria, Sort } from '../utils/criteria.model';
import { SearchCriteriaGroup } from '../utils/searchCriteriaGroup';
import { SearchCriteria } from '../utils/searchCriteria';
import { StatutNotificationFacade } from './statut-notification/statut-notification.facade';
import { UserFacade } from 'app/main/user/user.facade';
import { StatutNotification } from './statut-notification/statut-notification.model';
import { User } from 'app/main/user/user.model';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { locale as English } from '../notifications/i18n/en';
import { locale as French } from '../notifications/i18n/fr';
import { ofEntityType, EntityActionTypes } from '@briebug/ngrx-auto-entity';
import { Actions } from '@ngrx/effects';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TodoFacade } from 'app/main/calendar-todo/todo.facade';
import { Todo } from 'app/main/calendar-todo/todo.model';
import { TodoUpdateService } from 'app/main/calendar-todo/to-do-update.service';

@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'notifications'
})
export class NotificationsComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {
    notificationsUnread: StatutNotification[];
    notificationsClosed: StatutNotification[];
    notifications$: Observable<StatutNotification[]>;
    @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
    @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;
    tabs = ['Inbox', 'Watching'];
    unreadCount: number = 0;
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    statut: typeof StatutNotificationEnum = StatutNotificationEnum;
    criteria: Criteria = new Criteria();
    currentUser$: Observable<User>;
    currentUser: User;
    currentUserReady = false;
    destroyed$ = new Subject<boolean>();
    mySubscription: any;

    constructor(
        public _statutNotificationFacade: StatutNotificationFacade,
        private _userFacade: UserFacade,
        private _todoFacade: TodoFacade,
        private webSocketService: WebsocketService,
        private _overlay: Overlay,
        private _todoUpdateService: TodoUpdateService,
        private _viewContainerRef: ViewContainerRef,
        private _translateLoaderService: FuseTranslationLoaderService,
        private _translateService: TranslateService,
        private action$: Actions,
        private _router: Router,
        private _messageService: MessageService
    ) {
        // this._userFacade.getCurrentUser().subscribe(user => this.currentUser = user);
        this.notifications$ = this._statutNotificationFacade.all$;
        this._translateLoaderService.loadTranslations(English, French);
        this._userFacade.getCurrentUser()
            .pipe(
                takeWhile(() => !this.currentUser),
                takeUntil(this.destroyed$)
            )
            .subscribe(user => {
                this.currentUser = user;
                if (this.currentUser)
                    this.currentUserReady = true;
            });
        this._router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.mySubscription = this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Trick the Router into believing it's last link wasn't previously loaded
                this._router.navigated = false;
            }
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this._initializeNotifications();
            this._subscribeToRealTimeNotifications();
        }, 0);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('notifications' in changes) {
            // Possible logic for handling changes if needed
        }
    }

    ngOnInit(): void {
        this.webSocketService.connect();
        this._initializeCriteria();
        this._subscribeToUserChanges();




        //this._statutNotificationFacade.loadAll(this.criteria);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.mySubscription?.unsubscribe();
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
    }

    openPanel(): void {
        if (!this._notificationsPanel || !this._notificationsOrigin) return;
        if (!this._overlayRef) this._createOverlay();
        this._loadNotifications();
        this._overlayRef.attach(new TemplatePortal(this._notificationsPanel, this._viewContainerRef));
    }

    closePanel(): void {
        this._overlayRef.detach();
    }

    markAllAsRead(): void {
        this.notificationsUnread.forEach(notification => {
            notification.statut = this.statut.Viewed;
        });
        this._statutNotificationFacade.updateMany(this.notificationsUnread);
        this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateManySuccess))
            .subscribe((succ) => {
                this._loadNotifications();
            });
        this._calculateUnreadCount();
        //this._statutNotificationFacade.markAllAsRead(this.notificationsUnread);
    }
    markAllAsUnRead(): void {
        this.notificationsUnread.forEach(notification => {
            notification.statut = this.statut.Created;
        });
        this._statutNotificationFacade.updateMany(this.notificationsUnread);
        this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateManySuccess))
            .subscribe((succ) => {
                this._loadNotifications();
            });
        this._calculateUnreadCount();
        //this._statutNotificationFacade.markAllAsRead(this.notificationsUnread);
    }
    clearAll(): void {
        this.notificationsUnread.forEach(notification => {
            notification.statut = this.statut.Closed;
        });
        this._statutNotificationFacade.updateMany(this.notificationsUnread);
        this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateManySuccess))
            .subscribe((succ) => {
                this._loadNotifications();
            });
        this._calculateUnreadCount();
        //this._statutNotificationFacade.markAllAsRead(this.notificationsUnread);
    }

    toggleRead(notification: StatutNotification): void {
        notification.statut = notification.statut === this.statut.Created ? this.statut.Viewed : this.statut.Created;
        this._statutNotificationFacade.update(notification);
        this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateSuccess))
            .subscribe((succ) => {
                this._loadNotifications();
            });
        this._calculateUnreadCount();
    }

    close(notification: StatutNotification): void {
        notification.close = true;
        if (notification.statut == StatutNotificationEnum.Viewed) {
            notification.statut = StatutNotificationEnum.Closed;
        }
        this._statutNotificationFacade.update(notification);
        const index = this.notificationsUnread.indexOf(notification);
        if (index !== -1) { // Vérifie si l'élément existe dans le tableau
            this.notificationsUnread.splice(index, 1); // Supprime l'élément du tableau

            //recreer le tableau des pannes non dupliqués


        }
        this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateSuccess))
            .subscribe((succ) => {
                this._loadNotifications();
            });
        this._calculateUnreadCount();

        /* const index = this.notifications.findIndex(n => n === notification);
        if (index !== -1) {
            this.notifications.splice(index, 1);
            console.log("here",index);
        } */
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    onChangeTabs(event: MatTabChangeEvent) {
        this._setCriteriaForTabChange(event.index);
        this._loadNotifications();
    }

    private _initializeNotifications(): void {
        try {
            this._setCriteria();
            this.notifications$ = this._statutNotificationFacade.all$;
            this._statutNotificationFacade.loadAll(this.criteria);
            this.notifications$.subscribe(notifications => {
                this.notificationsUnread = this.getUnreadNotifications(notifications);
                this.notificationsClosed = this.getClosedNotifications(notifications);
                this._calculateUnreadCount();
            });
        } catch (error) {
            console.error('Error during _initializeNotifications:', error);
        }
    }
    getCurrentUrl(): string {
        return this._router.url;
    }
    private _subscribeToRealTimeNotifications(): void {
        this.webSocketService.getRealTimeNotifications()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(notification => {
                this.notificationsUnread.unshift(notification);
                this._calculateUnreadCount();
                this._messageService.add({
                    life: 3000,
                    severity: 'info',
                    summary: notification.notification.name,
                    detail: notification.notification.description
                });
                const url = this.getCurrentUrl();
                if (notification.notification.source === "ToDo" && url.includes("calendar-todo")) {
                    if (!notification?.notification?.idSource) {
                        console.error('idSource is missing or invalid in notification:', notification);
                        return;
                    }
                    // Load the specific todo
                    this._todoFacade.load(notification.notification.idSource);
                    // Listen for the load success action
                    this.action$
                        .pipe(
                            ofEntityType(Todo, EntityActionTypes.LoadSuccess),
                            takeUntil(this.destroyed$)
                        )
                        .subscribe((success: any) => {
                            const todo = success.entity as Todo;

                            if (todo && todo.datePrevueDebut) {
                                // Extract the date of the todo
                                const todoDate = new Date(todo.datePrevueDebut).toISOString().split('T')[0] + 'T00:00:00Z';
                                // Reload todos for this date
                                this._todoFacade.getTodoByDate({
                                    date: todoDate,
                                }).subscribe({
                                    next: (todos) => {
                                        // Notify CalendarTodoComponent to update the list
                                        this._todoUpdateService.notifyTodoUpdate(todoDate, todos);
                                    },
                                    error: (err) => {
                                        console.error('Error loading todos for date:', err);
                                    }
                                });
                            } else {
                                console.error('Todo or datePrevueDebut is missing:', todo);
                            }
                        }, (error) => {
                            console.error('Error in load action:', error);
                        });
                }
            }, (error) => {
                console.error('WebSocket subscription error:', error);
            });
    }

    private _initializeCriteria(): void {
        this._setCriteria();
        this._statutNotificationFacade.loadAll(this.criteria);
    }

    private _subscribeToUserChanges(): void {
        this._userFacade.getCurrentUser().subscribe(user => this.currentUser = user);
    }

    private _createOverlay(): void {
        this._overlayRef = this._overlay.create({
            hasBackdrop: true,
            backdropClass: 'fuse-backdrop-on-mobile',
            scrollStrategy: this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
                .withLockedPosition()
                .withPush(true)
                .withPositions([
                    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
                    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
                    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
                    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
                ])
        });

        this._overlayRef.backdropClick().subscribe(() => this._overlayRef.detach());
    }

    private _calculateUnreadCount(): void {
        this.unreadCount = this.notificationsUnread
            ?.filter(notification => notification.statut === this.statut.Created && !notification.close)
            .length || 0;
    }

    private _setCriteria(): void {
        //attendre que currentUserReady soit défini à true, ce qui se produit lorsque this.currentUser est prêt.
        const waitCurrentUser = () => {
            return new Promise<void>((resolve) => {
                const intervalId = setInterval(() => {
                    if (this.currentUserReady) {
                        clearInterval(intervalId);
                        resolve();
                    }
                }, 100); // Vérifie toutes les 100 millisecondes si currentUserReady est défini à true
            });
        };

        waitCurrentUser().then(() => {
            if (this.currentUser) {
                const searchCriterias = [
                    //new SearchCriteria('close', '=', false),
                    new SearchCriteria('user.id', '=', this.currentUser.id)
                ];
                this.criteria.sort = new Sort();
                this.criteria.sort.dir = "desc";
                this.criteria.sort.field = "notification.date";
                this.criteria.filter = [new SearchCriteriaGroup(searchCriterias)];
            }
        });

    }

    private _setCriteriaForTabChange(tabIndex: number): void {
        const searchCriterias = [
            // new SearchCriteria('close', '=', tabIndex !== 0),
            new SearchCriteria('user.id', '=', this.currentUser.id)
        ];
        this.criteria.filter = [new SearchCriteriaGroup(searchCriterias)];
    }

    private _loadNotifications(): void {
        this.notifications$ = this._statutNotificationFacade.all$;
        this._statutNotificationFacade.loadAll(this.criteria);
        this.notifications$.subscribe(notifications => {
            this.notificationsUnread = this.getUnreadNotifications(notifications);
            this.notificationsClosed = this.getClosedNotifications(notifications);
        });
    }
    getUnreadNotifications(notifications: StatutNotification[]): StatutNotification[] {
        return notifications.filter(notification =>
            ((notification.statut === this.statut.Created) || (notification.statut === this.statut.Viewed)) && !notification.close && notification.user?.id == this.currentUser.id
        );
    }
    getClosedNotifications(notifications: StatutNotification[]): StatutNotification[] {
        return notifications.filter(notification =>
            notification.statut == this.statut.Closed || notification.close
        );
    }
    navigateTo(notification: StatutNotification, source: string, idSource: number): void {

        // window.location.replace(`/${source.toLowerCase()}s/${idSource}`);
        /* this._router.navigateByUrl(`/${source.toLowerCase()}s/${idSource}`, { skipLocationChange: true }).then(() => {
            this._router.navigate([`/${source.toLowerCase()}s/${idSource}`]);
        }); */
        /*  this._router.navigate(['/' + source.toLowerCase()+'s', idSource]).then(() => {
             window.location.replace(`/${source.toLowerCase()}s/${idSource}`);
           }); */

        if (source.toLowerCase() == 'indicateur') {
            /* this._router.navigate(['/' + source.toLowerCase()+'s/historique' , idSource], {
                 queryParams: { id: idSource } // Pass the 'id' as a query parameter
             });
             */
            this._router.navigate(['/indicateurs', 'historique', idSource], { queryParams: { val: 0 } });

        } else if (source.toLowerCase() == 'chat') {

        } else if (source.toLowerCase() == 'ged') {

        } else {
            this._router.navigate(['/' + source.toLowerCase() + 's', idSource]);
        }
        if (notification.statut === this.statut.Created) {
            notification.statut = this.statut.Viewed;
            this._statutNotificationFacade.update(notification);
            this.action$.pipe(takeUntil(this.destroyed$), ofEntityType(StatutNotification, EntityActionTypes.UpdateSuccess))
                .subscribe((succ) => {
                    this._loadNotifications();
                });
            this._calculateUnreadCount();
        }
        this.closePanel();
    }

}
